export function compare(a, b, field) {
    if (
        typeof a[field] === "string" &&
        typeof b[field] === "string"
    ) {
        if (
            a[field].normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
            b[field].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        ) {
            return -1;
        }
        if (
            a[field].normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
            b[field].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        ) {
            return 1;
        }
    } else {
        if (a[field] < b[field]) {
            return -1;
        }
        if (a[field] > b[field]) {
            return 1;
        }
    }
    return 0;
}